<template>
  <div class="referred">
    <v-card-text>
      <div class="req-list">
        <div class="req-card" :style="`padding: 2px; ${item.selected ? 'background:lightskyblue;':''}`"
             v-for="(item,index) in list"
             :key="item.Id" v-longclick="() => long_click(item,index)">
          <div>
            <div class="row ">
              <div class="col-6">
                <div
                  class="req-name"
                  v-text="item.RequestName"
                ></div>
              </div>
              <div class="col-3">
                <div
                  class="req-name"
                  v-text="item.RequestCode"
                ></div>

              </div>
              <div class="col-3">
                <div
                  class="req-name"
                  v-text="item.FactorCode"
                ></div>
              </div>
              <div class="col-6">
                <div
                  class="req-name"

                >{{item.Amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} تومان</div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <v-btn class="width-100-p" color="primary"
             v-if="list.filter(x=>x.selected == true).length>0"
             v-on:click="add_pay_factor()">
        پرداخت
      </v-btn>
    </v-card-text>

  </div>

</template>
<script>
import InfiniteLoading from 'vue-infinite-loading'
import Vue from 'vue'
import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import {bus} from '../../main'
import {longClickDirective} from 'vue-long-click'
import mapboxgl from "mapbox-gl";

const longClickInstance = longClickDirective({delay: 500, interval: 5000})
Vue.directive('longclick', longClickInstance)
const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}

export default {
  props: [
    'passing_data'
  ],

  data() {
    return {
      list: [],

    }
  },
  components: {
    InfiniteLoading,
    Treeselect
  },
  watch: {},
  mounted() {
    this.get_data();
  },

  methods: {
    long_click(item, index) {
      if (item.selected) {
        // this.list[index].selected = false
        Vue.set(this.list[index], 'selected', false);
      } else {
        // this.list[index].selected = true
        Vue.set(this.list[index], 'selected', true);

      }
      console.log("long click ", this.list[index])
    },
    get_data() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      console.log()
      const send_data = {
        UserId: user_id,
        txtCode: "",
        fdate: "",
        sdate: "",
      }

      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetFactorUnPaid', send_data, {})
        .then(response => {
          self.list = response.data.items
        }).catch(e => {
        this.errors.push(e)
      })
    },
    add_pay_factor() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      let pros = []
      this.list.filter(x => x.selected == true).forEach(function (val) {

        pros.push({
          "name": val.RequestCode,
          "price": val.Amount,
          "summary": val.MasterFactorId,
        })

      })


      const send_data = {
        products: JSON.stringify(pros),
        customer_mobile: "0"+localStorage.getItem("phone").substring(3),
        customer_name: JSON.parse(localStorage.getItem('profile')).UserName,
        economic_code: "",
        document_code: "سهم فروش",
        summary: "سند پرداخت فروش های انجام شده",
      }
var formData = new FormData();
      formData.append("products",JSON.stringify(pros))
      formData.append("customer_mobile","0"+localStorage.getItem("phone").substring(3))
      formData.append("customer_name",JSON.parse(localStorage.getItem('profile')).UserName)
      formData.append("economic_code","")
      formData.append("document_code","سهم فروش")
      formData.append("summary","سند پرداخت فروش های انجام شده")
      // this.axios.post('/Register' , send_data,{
      this.axios.post('https://pay.zoodkomak.com/api/add_factor_from_zoodkomak', formData, {})
        .then(response => {
          if(response.data.error==0){
            var url = "https://pay.zoodkomak.com/i/"+response.data.unique_code;
window.open(url,"_self")
          }else{
            bus.$emit('show_toast', [2000, response.data.msg])

          }
        }).catch(e => {
        this.errors.push(e)
      })
    },

  }
}
</script>
